module.exports = __webpack_public_path__ + "31fcff85f9654619b5399b93cf529819.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/ball-tennis-racket-s.png
// module id = 2588
// module chunks = 0